import Header from "../header/header";
import NavBar from "../nav/nav-bar";
import MyThingsNav from "./my-things-nav";
import { useState, useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { NotificationContainer } from "react-notifications";
import "react-notifications/lib/notifications.css";
import "../../src/task.css";
import { HiDocumentReport } from "react-icons/hi";
import Service from "../webservice/http";
import ClipLoader from "react-spinners/ClipLoader";

const MyThingsQualityAudit = () => {
  const history = useHistory();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [importing, setImporting] = useState(false);
  const [expandedRows, setExpandedRows] = useState({});
  const [search, setSearch] = useState("");

  const services = useMemo(() => new Service(), []);

  const toggleRow = (e, id) => {
    e.stopPropagation();
    setExpandedRows((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  async function fetchAuditLogs(fetchAll = false) {
    setLoading(true);
    try {
      const res = await services.get(
        "api/call_verification/deviance_analysis_calls/?page=1",
      );
      const callListData = res?.data || [];

      const callsToProcess = fetchAll
        ? callListData
        : callListData.filter((call) => call.call_reviewed === true);

      const insightResults = await Promise.all(
        callsToProcess.map((call) =>
          services
            .get(`api/call/${call.call_id}/call_insight/`)
            .then((insight) => ({ call, insight }))
            .catch(() => ({ call, insight: null })),
        ),
      );

      const auditLogs = [];

      insightResults.forEach(({ call, insight }) => {
        const editHistory =
          insight?.edit_history?.edited_early_sz_transcription || [];

        const latestEdit =
          editHistory.length > 0 ? editHistory[editHistory.length - 1] : {};

        const diffs = (latestEdit.changes || []).map((change) => ({
          speaker: change.speaker,
          original: change.old_dialogue,
          revised: change.new_dialogue,
        }));

        const editedAtRaw = latestEdit.edited_at || "";
        const editedAtDate = editedAtRaw
          ? editedAtRaw.replace("T", " ").substring(0, 19)
          : call.call_date;

        const hasEditsAndReviewed =
          editHistory.length > 0 && call.call_reviewed === true;

        auditLogs.push({
          id: call.call_id,
          callId: call.call_reference || call.call_id,
          timestamp: editedAtDate,
          user: latestEdit.edited_by || "—",
          customerName: call.customer_name || call._call_customer_name || "—",
          changedBy: latestEdit.edited_by || "—",
          wordChanges:
            latestEdit.total_words_added ?? latestEdit.words_changed ?? 0,
          sentenceChanges: latestEdit.lines_changed || 0,
          version: latestEdit.version_number || 1,
          editedAt: editedAtRaw ? editedAtRaw.split("T")[0] : call.call_date,
          agent: call.agent || call._call_agent_name || "—",
          diffs,
          hasEditsAndReviewed,
          call_reviewed: call.call_reviewed,
        });
      });

      setLogs(auditLogs);
    } catch (err) {
      console.error("Error fetching audit logs:", err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchAuditLogs();
  }, []);

  const handleImport = () => {
    setImporting(true);
    setTimeout(() => {
      setImporting(false);
      fetchAuditLogs(true);
    }, 1500);
  };

  const filtered = logs.filter(
    (log) =>
      log.callId.toLowerCase().includes(search.toLowerCase()) ||
      log.customerName.toLowerCase().includes(search.toLowerCase()) ||
      log.user.toLowerCase().includes(search.toLowerCase()),
  );

  const speakerLabel = (speaker) => {
    if (!speaker) return "Speaker";
    const s = speaker.toLowerCase();
    if (s === "agent") return "Agent";
    if (s === "customer") return "Customer";
    if (s === "spk_0" || s === "spk0" || s === "spk1") return "Agent";
    if (s === "spk_1" || s === "spk2") return "Customer";
    return speaker;
  };

  const speakerStyle = (speaker) => {
    const label = speakerLabel(speaker);
    return label === "Agent"
      ? { background: "#dbeafe", color: "#1d4ed8" }
      : { background: "#fce7f3", color: "#9d174d" };
  };

  return (
    <div className="dashboard-body" style={{ paddingBottom: "20px" }}>
      <Header />
      <NavBar />
      <NotificationContainer />

      <div className="container-fluid" style={{ background: "#EEF2F5" }}>
        <div className="my-call bg-white">
          <div
            className="side-panel-with-table clearfix flex"
            style={{ display: "flex" }}
          >
            <MyThingsNav />

            <div className="call-table" style={{ marginBottom: "80px" }}>
              <div
                className="my-calls-column"
                style={{ padding: "15px 0px 0px 15px" }}
              >
                <div className="calls-top-pannel">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="pannel-heading clearfix">
                        <div className="pannel-heading-icon">
                          <HiDocumentReport size="22px" />
                        </div>
                        <div className="pannel-heading-info">
                          <h3>Transcription Audit</h3>
                          <p>Reviewer Transcription Change Log</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex justify-end items-center m-10 gap-6">
                <input
                  onChange={(e) => setSearch(e.target.value)}
                  type="text"
                  placeholder="Search by customer, call ID, reviewer..."
                  value={search}
                  style={{
                    border: "none",
                    background: "#eef2f5",
                    borderRadius: "10px",
                    width: "250px",
                    outline: "none",
                    paddingLeft: "8px",
                    height: "35px",
                  }}
                />
                <button
                  className="edit hover:text-white hover:ease-in-out hover:duration-600 text-white"
                  onClick={handleImport}
                  disabled={importing}
                  style={{
                    border: "1px solid lightgray",
                    padding: "8px 15px",
                    borderRadius: "10px",
                    cursor: importing ? "not-allowed" : "pointer",
                    opacity: importing ? 0.75 : 1,
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    transition: "all 0.2s",
                  }}
                >
                  {importing ? (
                    <>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14px"
                        height="14px"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        style={{
                          animation: "spin 0.8s linear infinite",
                        }}
                      >
                        <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
                      </svg>
                      Importing...
                    </>
                  ) : (
                    "Import Deviance Calls"
                  )}
                </button>
                <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
              </div>

              <div className="overflow-x-scroll">
                <table className="ss" style={{ border: "1px solid grey" }}>
                  <tr id="black-line">
                    {[
                      "Call ID",
                      "Timestamp",
                      "Customer",
                      "Reviewed By",
                      "Version",
                      "Total Changes",
                      "Manual Audit",
                      "Details",
                      "Action",
                    ].map((heading) => (
                      <th
                        key={heading}
                        className="left-0 bg-white border-b-2 border-gray-200 px-5 py-4 text-left text-xl font-semibold tracking-wider text-black"
                      >
                        {heading}
                      </th>
                    ))}
                  </tr>

                  <tbody>
                    {loading && (
                      <tr>
                        <td
                          colSpan="9"
                          style={{ textAlign: "center", padding: "40px" }}
                        >
                          <ClipLoader color="#2056FF" size="40px" />
                        </td>
                      </tr>
                    )}

                    {!loading && filtered.length === 0 && (
                      <tr>
                        <td
                          colSpan="9"
                          style={{
                            textAlign: "center",
                            padding: "40px",
                            color: "#999",
                          }}
                        >
                          No audit logs found
                        </td>
                      </tr>
                    )}

                    {!loading &&
                      filtered.map((log) => {
                        const isExpanded = !!expandedRows[log.id];
                        const totalChanges =
                          log.wordChanges + log.sentenceChanges;

                        return (
                          <>
                            <tr
                              key={log.id}
                              className="cursor-pointer"
                              onClick={
                                () =>
                                  history.push(
                                    `/call/${log.id}/call-transcription-audit`,
                                  )

                                // /call/90df7777-c219-414c-98d3-82a643a2fa12/call-transcription-audit
                              }
                            >
                              <td className="border-b border-gray-200 px-5 py-2 text-xs">
                                <p
                                  className="whitespace-no-wrap text-left text-sky-700"
                                  style={{
                                    fontWeight: "600",
                                    fontFamily: "monospace",
                                    fontSize: "12px",
                                  }}
                                >
                                  {log.callId.substring(0, 8).toUpperCase()}
                                </p>
                              </td>

                              <td className="border-b border-gray-200 px-5 py-2 text-xs">
                                <p className="whitespace-nowrap text-left text-gray-900">
                                  {log.timestamp.split(" ")[0]}
                                </p>
                                <p
                                  className="whitespace-nowrap text-left"
                                  style={{ color: "#999", fontSize: "11px" }}
                                >
                                  {log.timestamp.split(" ")[1]?.substring(0, 8)}
                                </p>
                              </td>

                              <td className="border-b border-gray-200 px-5 py-2 text-xs">
                                <p className="whitespace-nowrap text-left text-gray-900">
                                  {log.customerName || "—"}
                                </p>
                              </td>

                              <td className="border-b border-gray-200 px-5 py-2 text-xs">
                                <p className="whitespace-no-wrap text-left text-gray-900">
                                  {log.agent}
                                </p>
                              </td>

                              <td className="border-b border-gray-200 px-5 py-2 text-xs">
                                <span
                                  style={{
                                    background: "#eef2f5",
                                    color: "#374151",
                                    padding: "2px 10px",
                                    borderRadius: "20px",
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    border: "1px solid #d1d5db",
                                  }}
                                >
                                  v{log.version}
                                </span>
                              </td>

                              <td className="border-b border-gray-200 px-5 py-2 text-xs">
                                <span
                                  style={{ fontSize: "13px", color: "#374151" }}
                                >
                                  {totalChanges}
                                  <span
                                    style={{
                                      // color: "#9ca3af",
                                      fontSize: "13px",
                                      marginLeft: "4px",
                                    }}
                                  >
                                    ({log.sentenceChanges}S / {log.wordChanges}
                                    W)
                                  </span>
                                </span>
                              </td>

                              <td className="border-b border-gray-200 px-5 py-2 text-xs">
                                {log?.call_reviewed ? (
                                  <p
                                    className="flex justify-start font-bold"
                                    style={{ color: "green", fontSize: "16px" }}
                                  >
                                    <i
                                      className="fa fa-check-circle"
                                      aria-hidden="true"
                                    ></i>
                                  </p>
                                ) : (
                                  <p
                                    className="flex justify-start font-bold"
                                    style={{ color: "red", fontSize: "16px" }}
                                  >
                                    <i
                                      className="fa fa-times-circle"
                                      aria-hidden="true"
                                    ></i>
                                  </p>
                                )}
                              </td>

                              <td className="border-b border-gray-200 px-5 py-2 text-xs">
                                <div
                                  onClick={(e) => {
                                    if (log.hasEditsAndReviewed) {
                                      toggleRow(e, log.id);
                                    } else {
                                      e.stopPropagation();
                                    }
                                  }}
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "4px",
                                    border: "1px solid lightgray",
                                    padding: "6px 14px",
                                    borderRadius: "10px",
                                    cursor: log.hasEditsAndReviewed
                                      ? "pointer"
                                      : "not-allowed",
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    color: log.hasEditsAndReviewed
                                      ? isExpanded
                                        ? "white"
                                        : "#374151"
                                      : "#9ca3af",
                                    background: log.hasEditsAndReviewed
                                      ? isExpanded
                                        ? "#271078"
                                        : "white"
                                      : "#f3f4f6",
                                    transition: "all 0.2s",
                                    userSelect: "none",
                                    opacity: log.hasEditsAndReviewed ? 1 : 0.6,
                                  }}
                                >
                                  Details
                                  {isExpanded && log.hasEditsAndReviewed ? (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      height="16px"
                                      viewBox="0 -960 960 960"
                                      width="16px"
                                      fill="currentColor"
                                    >
                                      <path d="m280-400 200-200 200 200H280Z" />
                                    </svg>
                                  ) : (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      height="16px"
                                      viewBox="0 -960 960 960"
                                      width="16px"
                                      fill="currentColor"
                                    >
                                      <path d="M480-360 280-560h400L480-360Z" />
                                    </svg>
                                  )}
                                </div>
                              </td>
                              <td
                                className={`border-b border-gray-200 px-5 py-2  w-40 text-xs cursor-pointer whitespace-nowrap`}
                                style={{ whiteSpace: "nowrap" }}
                              >
                                <button
                                  className="edit hover:text-white hover:ease-in-out hover:duration-600 text-white"
                                  style={{
                                    border: "1px solid lightgray",
                                    padding: "10px 15px",
                                    borderRadius: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    history.push(`/call/${log.id}/call-insight`)
                                  }
                                >
                                  Edit
                                </button>
                              </td>
                            </tr>

                            {isExpanded && (
                              <tr key={`${log.id}-detail`}>
                                <td
                                  colSpan="9"
                                  style={{
                                    padding: "0",
                                    background: "#f8fafc",
                                    borderTop: "1px solid #e5e7eb",
                                  }}
                                >
                                  <div style={{ padding: "16px 24px 20px" }}>
                                    <p
                                      style={{
                                        fontSize: "11px",
                                        fontWeight: "700",
                                        color: "#4a4a6a",
                                        marginBottom: "12px",
                                        textTransform: "uppercase",
                                        letterSpacing: "0.05em",
                                      }}
                                    >
                                      Transcription Changes
                                    </p>

                                    {log.diffs.length === 0 ? (
                                      <p
                                        style={{
                                          color: "#9ca3af",
                                          fontSize: "13px",
                                        }}
                                      >
                                        No line-level changes recorded.
                                      </p>
                                    ) : (
                                      <table
                                        style={{
                                          width: "100%",
                                          borderCollapse: "collapse",
                                          border: "1px solid #e2e8f0",
                                          borderRadius: "8px",
                                          overflow: "hidden",
                                          fontSize: "13px",
                                        }}
                                      >
                                        <thead>
                                          <tr style={{ background: "#f1f5f9" }}>
                                            <th
                                              style={{
                                                padding: "8px 14px",
                                                textAlign: "left",
                                                fontWeight: "700",
                                                color: "#64748b",
                                                fontSize: "11px",
                                                textTransform: "uppercase",
                                                letterSpacing: "0.05em",
                                                width: "100px",
                                                borderBottom:
                                                  "1px solid #e2e8f0",
                                              }}
                                            >
                                              Speaker
                                            </th>
                                            <th
                                              style={{
                                                padding: "8px 14px",
                                                textAlign: "left",
                                                fontWeight: "700",
                                                color: "#b02a37",
                                                fontSize: "11px",
                                                textTransform: "uppercase",
                                                letterSpacing: "0.05em",
                                                borderBottom:
                                                  "1px solid #e2e8f0",
                                              }}
                                            >
                                              Original
                                            </th>
                                            <th
                                              style={{
                                                padding: "8px 14px",
                                                textAlign: "left",
                                                fontWeight: "700",
                                                color: "#1a7a36",
                                                fontSize: "11px",
                                                textTransform: "uppercase",
                                                letterSpacing: "0.05em",
                                                borderBottom:
                                                  "1px solid #e2e8f0",
                                              }}
                                            >
                                              Revised
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {log.diffs.map((diff, idx) => (
                                            <tr
                                              key={idx}
                                              style={{
                                                borderTop:
                                                  idx > 0
                                                    ? "1px solid #f0f0f0"
                                                    : "none",
                                                background: "white",
                                              }}
                                            >
                                              <td
                                                style={{
                                                  padding: "10px 14px",
                                                  verticalAlign: "top",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    ...speakerStyle(
                                                      diff.speaker,
                                                    ),
                                                    padding: "2px 8px",
                                                    borderRadius: "10px",
                                                    fontSize: "11px",
                                                    fontWeight: "600",
                                                  }}
                                                >
                                                  {speakerLabel(diff.speaker)}
                                                </span>
                                              </td>
                                              <td
                                                style={{
                                                  padding: "10px 14px",
                                                  color: "#7f1d1d",
                                                  background:
                                                    "rgba(255,0,0,0.03)",
                                                  verticalAlign: "top",
                                                  lineHeight: "1.5",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    textDecoration:
                                                      "line-through",
                                                    opacity: 0.75,
                                                  }}
                                                >
                                                  {diff.original}
                                                </span>
                                              </td>
                                              <td
                                                style={{
                                                  padding: "10px 14px",
                                                  color: "#14532d",
                                                  background:
                                                    "rgba(0,200,80,0.04)",
                                                  verticalAlign: "top",
                                                  lineHeight: "1.5",
                                                }}
                                              >
                                                {diff.revised}
                                              </td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    )}

                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "10px",
                                        marginTop: "14px",
                                        flexWrap: "wrap",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: "10px",
                                          flexWrap: "wrap",
                                        }}
                                      >
                                        <span
                                          style={{
                                            background:
                                              "rgba(255, 196, 226, 0.4)",
                                            color: "#4a1a2c",
                                            padding: "5px 14px",
                                            borderRadius: "8px",
                                            fontSize: "13px",
                                            fontWeight: "600",
                                          }}
                                        >
                                          Sentence Changed:{" "}
                                          {log.sentenceChanges}
                                        </span>
                                        <span
                                          style={{
                                            background:
                                              "rgba(255, 255, 0, 0.3)",
                                            color: "#4a3d00",
                                            padding: "5px 14px",
                                            borderRadius: "8px",
                                            fontSize: "13px",
                                            fontWeight: "600",
                                          }}
                                        >
                                          Word Changed: {log.wordChanges}
                                        </span>
                                        <span
                                          style={{
                                            background:
                                              "rgba(0, 228, 255, 0.18)",
                                            color: "#004a52",
                                            padding: "5px 14px",
                                            borderRadius: "8px",
                                            fontSize: "13px",
                                            fontWeight: "600",
                                          }}
                                        >
                                          Edited On: {log.editedAt}
                                          <span
                                            style={{
                                              marginLeft: "12px",
                                              paddingLeft: "12px",
                                              borderLeft: "1px solid #bbb",
                                            }}
                                          >
                                            Version: {log.version}
                                          </span>
                                        </span>
                                      </div>

                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          history.push(
                                            `/call/${log.id}/transcription-audit`,
                                          );
                                        }}
                                        style={{
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: "6px",
                                          padding: "6px 16px",
                                          borderRadius: "8px",
                                          border: "1px solid #271078",
                                          background: "white",
                                          color: "#271078",
                                          fontSize: "13px",
                                          fontWeight: "600",
                                          cursor: "pointer",
                                          transition: "all 0.2s",
                                          whiteSpace: "nowrap",
                                        }}
                                        onMouseEnter={(e) => {
                                          e.currentTarget.style.background =
                                            "#271078";
                                          e.currentTarget.style.color = "white";
                                        }}
                                        onMouseLeave={(e) => {
                                          e.currentTarget.style.background =
                                            "white";
                                          e.currentTarget.style.color =
                                            "#271078";
                                        }}
                                      >
                                        View More
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          height="14px"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth="2.5"
                                        >
                                          <path d="M5 12h14M12 5l7 7-7 7" />
                                        </svg>
                                      </button>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyThingsQualityAudit;
